import React, { useEffect, useState } from 'react';
import { Form, Formik } from 'formik';
import useFetchUserDetails from './hooks/useFetchUserDetails';
import { ISubscriptionItem, IUser } from './models';
import { FormBooleanField } from 'components/formComponents/FormBooleanField';
import FormTextField from 'components/formComponents/FormTextField';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import ErrorMessage from 'components/errorMessage/ErrorMessage';
import { ERROR_MESSAGE } from 'appConstants';
import { useGetDashboardList } from 'pages/dashboard/useGetDashboardList';
import { Spinner } from 'components/spinner/Spinner';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id: number;
};

export const ViewUser: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  id,
}) => {
  const [initialValues, setInitialValues] = useState<IUser | null>(null);
  const [error, setError] = useState<string>('');

  useFetchUserDetails('view', id, setInitialValues, setError);

  const { dashboardListInfo, error: subscriptionsListError } =
    useGetDashboardList();

  const [subscriptionsList, setSubscriptionList] = useState<
    ISubscriptionItem[] | null
  >(null);

  useEffect(() => {
    if (dashboardListInfo) {
      const subjectsList = dashboardListInfo.map((item) => ({
        label: item.subject,
        fieldName: `b${item.subject.split(' ').join('')}`,
      }));
      setSubscriptionList(subjectsList);
    }
  }, [dashboardListInfo]);

  if (error)
    return (
      <PopupOrPanel
        isPopup={false}
        isOpen={panelOpen}
        hdrTitle={'View user'}
        position="right"
        primaryBtnTxt="Close"
        secondaryBtnTxt="Cancel"
        givenClass="ViewManagedUser"
        handleClose={() => togglePanelOpen(false)}
        handlePrimaryBtn={() => togglePanelOpen(false)}
        handleSecondaryBtn={() => togglePanelOpen(false)}
        width={560}
      >
        <ErrorMessage message={ERROR_MESSAGE} />
      </PopupOrPanel>
    );

  if (initialValues)
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={{}}
        onSubmit={() => {}}
      >
        {({ values }) => (
          <PopupOrPanel
            isPopup={false}
            isOpen={panelOpen}
            hdrTitle={'View user'}
            position="right"
            primaryBtnTxt="Close"
            secondaryBtnTxt="Cancel"
            givenClass="ViewManagedUser"
            handleClose={() => togglePanelOpen(false)}
            handlePrimaryBtn={() => togglePanelOpen(false)}
            handleSecondaryBtn={() => togglePanelOpen(false)}
            width={560}
          >
            {subscriptionsList ? (
              <Form>
                <FormTextField
                  label="First name"
                  field="firstName"
                  labelPosition="left"
                  required={true}
                  optionalTag={'optional'}
                  value={values.firstName}
                  readOnly={true}
                />
                <FormTextField
                  label="Last name"
                  field="lastName"
                  labelPosition="left"
                  required={true}
                  optionalTag={'optional'}
                  value={values.lastName}
                  readOnly={true}
                />
                <FormTextField
                  label="Email address"
                  field="emailAddress"
                  labelPosition="left"
                  required={true}
                  optionalTag={'optional'}
                  value={values.emailAddress}
                  readOnly={true}
                />
                <FormBooleanField
                  fieldName="bMainAccountHolder"
                  label="Main account holder"
                  labelPosition="left"
                  readOnly={true}
                />
                <h4 className="SpaceTopBtm">Platform access</h4>

                {subscriptionsList.map((item: any, index: number) => (
                  <FormBooleanField
                    key={index}
                    fieldName={item.fieldName}
                    label={item.label}
                    labelPosition="left"
                    readOnly={true}
                  />
                ))}
              </Form>
            ) : (
              <Spinner positionAbsolute />
            )}
          </PopupOrPanel>
        )}
      </Formik>
    );
  return null;
};
